import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import Modal from 'ui/layout/Modal'
import { ConfirmContent } from 'ui/partials/ConfirmContent'

const usePopupBlockModal = (): {
  /**
   * ポップアップブロックを検知したときに発火させるとモーダルを開く
   */
  showPopupBlockModal: () => void
  /**
   * この変数をjsx内に配置するとモーダルが表示される
   */
  popupBlockModalComponent: JSX.Element | null
} => {
  const { t } = useTranslation()
  const [showPopupBlockModal, setShowPopupBlockModal] = useState<boolean>(false)
  const popupBlockModalComponent = (
    <Modal
      open={showPopupBlockModal}
      handleClose={() => setShowPopupBlockModal(false)}
    >
      <ConfirmContent
        onSubmit={() => {
          setShowPopupBlockModal(false)
        }}
        submitLabel={t('閉じる')}
        title={t(
          'YaDoc Quickではポップアップウィンドウを使用します。設定で許可してください。'
        )}
      />
    </Modal>
  )
  return {
    showPopupBlockModal: () => setShowPopupBlockModal(true),
    popupBlockModalComponent,
  }
}

export default usePopupBlockModal
